"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getModifyOrganisationUrl;

function getModifyOrganisationUrl(organisationId, stage) {
  return "/organisations/edit/".concat(organisationId, "#").concat(stage);
}